import React from 'react'
import { Provider } from 'react-redux'
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom'
import { createStore, applyMiddleware } from 'redux' //compose
import thunk from 'redux-thunk'
import Loadable from 'react-loadable';
import { Dimmer, Loader } from 'semantic-ui-react'

import AppTemplateComponent from '../common/template/AppTemplateComponent'
import RootReducer from './RootReducer'

import { I18nextProvider } from "react-i18next"
import i18n from "../common/internationalization/i18n"
import LoginContainer from '../common/login/LoginContainer';
import { TenantContext, tenants } from '../tenant/TenantContex';
import DynamicSurveyContainer from '../modules/dynamic-survey/DynamicSurveyContainer';
import moment from 'moment';
import { logout } from '../common/login/login-form/LoginActions'
import { connect } from "react-redux"

//const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
//let store = createStore(RootReducer, composeEnhancers(applyMiddleware(thunk)))
let store = createStore(RootReducer, applyMiddleware(thunk))

const RooterLoader = () => (
  <Dimmer active inverted>
    <Loader>Loading</Loader>
  </Dimmer>
)

const LoadableHome = Loadable({
  loader: () => import('../home/HomeComponent'),
  loading: RooterLoader,
});

const LoadableSurveyDataVisualizationComponent = Loadable({
  loader: () => import('../modules/survey-data-visualization/SurveyDataVIsualizationContainer'),
  loading: RooterLoader,
});


const LoadableStatisticalTablesComponent = Loadable({
  loader: () => import('../modules/statistical-tables/StatisticalTablesComponentForOman'),
  loading: RooterLoader,
});


const LoadableDirectoryWizzardContainer = Loadable({
  loader: () => import('../modules/directory-of-manufactory/directory-wizzard/DirectoryWizzardContainer'),
  loading: RooterLoader,
});



const ScrollToTop = () => {
  window.scrollTo(0, 0);
  return null;
}

i18n.init({ lng: localStorage.getItem('activeLangCode') ? localStorage.getItem('activeLangCode') : 'en' }, function (err, t) {
  if (err)
    console.error(err)
});

moment.locale(localStorage.getItem('activeLangCode') ? localStorage.getItem('activeLangCode') : 'en');

const getSubdomain = () => {
  let hostname = window.location.hostname.toLowerCase();
  const hostnameSections = hostname.split(".");
  const first = hostnameSections[0];
  return first;
};

const LogoutComponent = (props) => {
  props.dispatch(logout());
  return <Redirect to={process.env.PUBLIC_URL + "/"} />
}

const LogoutContainer = connect()(LogoutComponent);


const RootContainer = (props) => {
  return (
    
      <Provider store={store}>
        <I18nextProvider i18n={i18n}>
          <Router>
          <TenantContext.Provider value={tenants[getSubdomain()] ? tenants[getSubdomain()] : tenants["statsurvey"]}>
            <AppTemplateComponent>
              <Route component={ScrollToTop} />
              <Switch>
                <Route exact path={process.env.PUBLIC_URL + "/"} component={LoadableHome} />
                {/* <Route path="/login" component={LoginContainer} /> */}
                <Route path="/survey_data_visualization" render={(props) => (
                  true /* store.getState().loginReducer.isLoggedIn */ ? (
                    <LoadableSurveyDataVisualizationComponent  {...props} />
                  ) : (
                      <div>
                        <LoadableHome>
                        </LoadableHome>
                        <LoginContainer {...props} />
                      </div>
                    )
                )} />
                <Route path="/directory_of_manufactory" render={(props) => (
                  true /*store.getState().loginReducer.isLoggedIn */ ? (
                    <LoadableDirectoryWizzardContainer  {...props} />
                  ) : (
                      <div>
                        <LoadableHome>
                        </LoadableHome>
                        <LoginContainer {...props} />
                      </div>
                    )
                )} />
                <Route path="/statistical_tables" render={(props) => (
                  true /* store.getState().loginReducer.isLoggedIn */ ? (
                    <LoadableStatisticalTablesComponent  {...props} />
                  ) : (
                      <div>
                        <LoadableHome>
                        </LoadableHome>
                        <LoginContainer {...props} />
                      </div>
                    )
                )} />
                <Route path={process.env.PUBLIC_URL + "/dynamic-survey"} render={(props) => (
                  store.getState().loginReducer.isLoggedIn ? (
                    <DynamicSurveyContainer  {...props} />
                  ) : (
                      <div>
                        <LoadableHome>
                        </LoadableHome>
                        <LoginContainer {...props} />
                      </div>
                    )
                )} />
                <Route exact path="/logout" render={() => (
                  <LogoutContainer />
                )} />
                <Route path="*" component={() => (<div>Page Not Found:(</div>)} />
              </Switch>
            </AppTemplateComponent>
            </TenantContext.Provider>
          </Router>
        </I18nextProvider>
      </Provider>
   
  )
}

export default RootContainer;   // instead of "export default App;"



// WEBPACK FOOTER //
// ./src/features/root/RootContainer.js